module.exports = __webpack_public_path__ + "e5c3d4dd5fa1f251007ebca757aa6966.svg";